// extracted by mini-css-extract-plugin
module.exports = {"popout":"Edit_popout__LYvnF","title":"Edit_title__9jDZq","section":"Edit_section__rqdou","error":"Edit_error__cdUQ4"};